// extracted by mini-css-extract-plugin
module.exports = {"collectionItemContainer":"CollectionItem_collectionItemContainer__n9F_q","itemTitle":"CollectionItem_itemTitle__XsRM_"};